import { getSelectioAxios, isEmpty } from '@/main';

export default class ProfileService {

  initializeUserPreference(userPreference) {
    return getSelectioAxios().put('/users/user-preference', userPreference)
      .then(result => result.data);
  }

  getDivisionListByportfolio(portfolioId) {
    return getSelectioAxios().get('/users/division/portfolio/' + String(isEmpty(portfolioId) ? 0 : portfolioId))
      .then(response => {
        return response.data;
      });
  }

  getUserPreferences(username, portfolioId, endpoint) {
    const body = {
      username: username,
      portfolioId: isEmpty(portfolioId) ? 0 : portfolioId,
      endpoint: endpoint,
    };
    return getSelectioAxios().post('/users/user-preference', body)
      .then(result => result.data);
  }

  upsertUserPreferences(userPreferences) {
    return getSelectioAxios().patch('/users/user-preference', userPreferences)
      .then(result => result.data);
  }

  getAllUsernameInUserPreferences(idPortfolio) {
    return getSelectioAxios().get('/users/portfolios/' + String(!isEmpty(idPortfolio) && idPortfolio > 0 ? idPortfolio : 0))
      .then(result => result.data);
  }

  searchUserPortfolios(filters) {
    return getSelectioAxios()
      .post('/users/portfolios', filters)
      .then(response => response.data);
  }

  getUsernameDivisionByPortfolio(username, idPortfolio) {
    return getSelectioAxios().get('/users/division/portfolio/' + String(isEmpty(idPortfolio) ? 0 : idPortfolio))
      .then(result => result.data);
  }

  updateUserDivisionFromUserPreference(username, division, idPortfolio) {
    const variables = {
      'user': username,
      'division': division,
    };
    return getSelectioAxios().put('/portfolios/' + idPortfolio + '/division/', variables)
      .then(result => result.data);
  }
}
